import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "view1" }
const _hoisted_2 = { class: "view2 radius-view1 main-view" }
const _hoisted_3 = { class: "freightTemplateAdd1" }

export function render(_ctx, _cache) {
  const _component_el_alert = _resolveComponent("el-alert")
  const _component_mi_title = _resolveComponent("mi-title")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_alert, {
        style: {"margin-bottom":"30px"},
        closable: false,
        title: "系统信息配置",
        type: "warning"
      }),
      _createVNode(_component_el_form, {
        ref: "refForm",
        model: _ctx.ruleForm,
        "label-width": "150px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_mi_title, { text: "系统信息" }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_form_item, {
              label: "发放积分",
              prop: "title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { type: "flex" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      placeholder: "审核通过后发放的积分",
                      modelValue: _ctx.ruleForm.jifen,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.ruleForm.jifen) = $event)),
                      style: {"width":"80%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "实名认证发放积分",
              prop: "title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { type: "flex" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      placeholder: "审核通过后发放的积分",
                      modelValue: _ctx.ruleForm.autoJifen,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.ruleForm.autoJifen) = $event)),
                      style: {"width":"80%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "手机号认证发放积分",
              prop: "title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { type: "flex" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      placeholder: "审核通过后发放的积分",
                      modelValue: _ctx.ruleForm.phoneJifen,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.ruleForm.phoneJifen) = $event)),
                      style: {"width":"80%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "生日奖励积分",
              prop: "title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { type: "flex" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      placeholder: "请输入生日奖励积分",
                      modelValue: _ctx.ruleForm.birthDayJifen,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.ruleForm.birthDayJifen) = $event)),
                      style: {"width":"80%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "公众号链接地址",
              prop: "title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { type: "flex" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      placeholder: "公众号链接地址",
                      modelValue: _ctx.ruleForm.jumpUrl,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.ruleForm.jumpUrl) = $event)),
                      style: {"width":"80%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_form_item, { style: {"margin-top":"20px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[5] || (_cache[5] = $event => (_ctx.submitForm(_ctx.ruleForm)))
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("立即修改")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ])
  ]))
}